import { toUint8Array } from 'js-base64'
import * as Y from 'yjs'
import { getElementValue } from '../lib-v2/get-shared-type.js'
import { serializeText } from './serialize-text.js'

/**
 * Extract serialized text content from a YDoc state.
 *
 * Accepts either a base64-encoded YDoc string (legacy inline `entity.yDoc` field)
 * or a `Uint8Array` of YDoc updates (typical when fetched from S3 storage). Use
 * this when you need a quick read-only view of a YDoc-backed entity's content
 * — for previews, search indexing, or any UI that doesn't need to mount a Slate
 * editor. Returns the empty string when the YDoc has no extractable text.
 *
 * Catches and swallows decode errors so callers can use this inline without
 * try/catch — a malformed input just yields no preview.
 */
export const textFromYDoc = (input: string | Uint8Array | undefined | null): string => {
  if (!input) {
    return ''
  }
  try {
    const doc = new Y.Doc()
    const bytes = typeof input === 'string' ? toUint8Array(input) : input
    Y.applyUpdate(doc, bytes)
    const value = getElementValue(doc)
    return serializeText({ editor: { children: value } })
  } catch {
    return ''
  }
}
